<template>
  <LKRoadmapsFeedModalContainer
    content-class="LKRoadmapsFeedModalHistoryTable"
    @close="$emit('close')"
  >
    <div class="LKRoadmapsFeedModalHistoryTable__header">
      <div class="text-lg-bold">
        История изменений
      </div>

      <IconClose
        @click.native="close"
      />
    </div>

    <BTableCommon
      type="event-history"
      :list="list"
      :skeleton="isLoading"
      class="LKRoadmapsFeedModalHistoryTable__table"
    />
  </LKRoadmapsFeedModalContainer>
</template>

<script>
import { RoadmapEventsApi } from '@/api/resources'

import BTableCommon from '@/components/tables/BTableCommon.vue'
import LKRoadmapsFeedModalContainer from './LKRoadmapsFeedModalContainer.vue'
import IconClose from '@/components/lk/icons/LKIconClose.vue'


export default {
  name: 'LKRoadmapsFeedModalHistoryTable',
  components: {
    BTableCommon,
    LKRoadmapsFeedModalContainer,
    IconClose,
  },
  props: {
    options: {
      type: Object,
    },
  },
  data: () => ({
    list: [],
    isLoading: false,
  }),
  created() {
    this.getData()
  },
  methods: {
    close(flag = false) {
      this.$emit('close', flag)
    },
    async getData() {
      this.isLoading = true
      const api = new RoadmapEventsApi()
      const eventId = this.options.event_id

      try {
        const { data } = await api.getHistory(eventId)
        this.list = data
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
$modal-padding: 20px;

.LKRoadmapsFeedModalHistoryTable {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 2;
  width: 800px;
  max-width: 100%;
  min-height: 200px;
  max-height: calc(100% - #{2 * $modal-padding});
  margin: $modal-padding;
  overflow: auto;
  background-color: $color-white;
  border-radius: 4px;
  box-shadow: 7px 7px 20px 1px rgba(0, 0, 0, 0.05);

  @media screen and (max-width: #{800px + 2 * $modal-padding}) {
    width: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;

    @media screen and (max-width: #{800px + 2 * $modal-padding}) {
      padding: 10px;
    }
  }

  &__table {
    width: 100%;
    height: 100%;

    .v-data-table-header-mobile {
      display: none;
    }
  }
}
</style>
